import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { props as stylableButtonPreviewMapperProps } from '../../StylableButton/viewer/StylableButton.previewMapper';

export default createComponentPreviewMapperModel({
  props: stylableButtonPreviewMapperProps,
});
